/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_GoodInputs */

const en_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good`)
};

const es_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bueno`)
};

const fr_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon`)
};

const de_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gut`)
};

const ja_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`良い`)
};

const zh_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`良好`)
};

const ar_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جيد`)
};

const id_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baik`)
};

const it_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buono`)
};

const ru_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошее`)
};

const pt_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom`)
};

const ko_val_good = /** @type {(inputs: Val_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좋음`)
};

/**
* | output |
* | --- |
* | "Good" |
*
* @param {Val_GoodInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_good = /** @type {((inputs?: Val_GoodInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_GoodInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_good(inputs)
	if (locale === "es") return es_val_good(inputs)
	if (locale === "fr") return fr_val_good(inputs)
	if (locale === "de") return de_val_good(inputs)
	if (locale === "ja") return ja_val_good(inputs)
	if (locale === "zh") return zh_val_good(inputs)
	if (locale === "ar") return ar_val_good(inputs)
	if (locale === "id") return id_val_good(inputs)
	if (locale === "it") return it_val_good(inputs)
	if (locale === "ru") return ru_val_good(inputs)
	if (locale === "pt") return pt_val_good(inputs)
	return ko_val_good(inputs)
});